import { Component, Input } from '@angular/core'
import { AnchorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-desktop-menu',
  templateUrl: './desktop-menu.component.html',
})
export class DesktopMenuComponent {
  @Input() data: any
  @Input() identifier: string
  @Input() medias: []

  constructor(public anchorService: AnchorService) {
  }
}
